import { tabSlice } from "./tabSlice";
import { cartSlice } from "./cartSlice";
import { filterSlice } from "./filterSlice";
import { mytradeSlice } from "./mytradeSlice";
import { homeSlice } from "./homeSlice";
import { profileSlice } from "./profileSlice";

export const slices = {
  tabSlice,
  cartSlice,
  filterSlice,
  mytradeSlice,
  homeSlice,
  profileSlice,
};
